import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Box } from "./components/styled/Elements";
import { publicRoutes } from "./routes/PublicRoutes";
import AdminLayout from "./layout/AdminLayout";
import { privateRoutes } from "./routes/PrivateRoutes";
import PrivateRoute from "./routes/PrivateRouteWrapper";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import useAuth from "./context/authContext";
import PageNotFound from "./components/common/pageNotFound/PageNotFound";
import PermissionWrapper from "./pages/admin/permissionWrapper/PermissionWrapper";
import { matchPath } from "react-router-dom";

const App = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const authRoutes = [
    "/login",
    "/signup",
    "/login-with-phone",
    "/reset-password",
    "/invoice/:id",
    "/payment-success",
    "/payment-failed",
    "/payment-pending",
  ];

  useEffect(() => {
    document.title = t("my_office");

    const isAuthRoute = authRoutes.some(path => 
      matchPath({ path, end: true }, location.pathname)
    );

    if (isAuthenticated) {
      if (location.pathname === "/" || isAuthRoute) {
        navigate("/products-categories", { replace: true });
      }
    } else {
      if (!isAuthRoute && location.pathname !== "/") {
        navigate("/login", { replace: true });
      }
    }
  }, [isAuthenticated, location.pathname, navigate, t]);

  return (
    <>
      <ToastContainer
        position={language === "ar" ? "top-left" : "top-right"}
        rtl={language === "ar"}
      />
      <Box>
        <Routes>
          {publicRoutes.map((route, key) => (
            <Route key={key} {...route} />
          ))}
          <Route element={<AdminLayout />} path="/">
            {privateRoutes.map((route, key) => (
              <Route
                key={key}
                path={route.path}
                element={
                  <PermissionWrapper
                    isPermitted={!!route?.permission}
                    moduleId={route?.permission?.collection}
                    actionId={route?.permission?.action}
                    featureId={route?.permission?.feature}
                  >
                    <PrivateRoute
                      isAuthenticated={isAuthenticated}
                      element={route.element}
                    />
                  </PermissionWrapper>
                }
              />
            ))}
          </Route>
          <Route
            path="*"
            element={
              <PageNotFound
                btnUrl="/products-categories"
                btnLabel={t("home")}
              />
            }
          />
        </Routes>
      </Box>
    </>
  );
};

export default App;
